<template>
  <div class="community-inline-list-new">
    <div
      v-for="(community, index) in communities"
      :key="community.title + index"
      class="community-inline-list-new__item"
    >
      <SvgIcon
        class="community-inline-list-new__icon"
        :source="$options.source"
        :icon="`service-${community.icon}`"
        :size="20"
      />
      <LinkOrText
        target="_blank"
        appearance="blue"
        rel="noopener noreferer"
        :item="community"
        @click.native="sendAnalytics(community)"
      />
    </div>
  </div>
</template>

<script>
import SvgIcon from 'src/components/icons/SvgIcon/SvgIcon.vue';
import LinkOrText from 'src/components/LinkOrText/LinkOrText.vue';

export default {
  name: 'CommunityInlineListNew',
  components: { LinkOrText, SvgIcon },
  source: '/images/services.svg',
  props: {
    communities: {
      type: Array,
      required: true,
    },
  },
  methods: {
    sendAnalytics(community) {
      const eventName = `contacts_comm_${community.icon}`;

      window.helpers.trackEventByName(eventName, {
        event_category: 'user_card',
      });
    },
  },
};
</script>
